/**
 * @date: 2022-04-08
 * @author: Kevin Hsiau <khsiau@max.md>
 * @copy: (C) Copyright 2022 MaxMD Corporation, All Rights Reserved.
 */

import * as React from 'react';
import {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import ContributionsAsList from "../Contributions/ContributionsAsList";
import {styled} from "@mui/material";
import {useDispatch, useSelector} from "react-redux";
import {getAllHisps} from "../features/allHispsSlice";
import {CustomBackdrop} from "../utils/customStyles";
import PublishedErrorTable from "./PublishedErrorTable";
import PublishedScoreTable from "./PublishedScoreTable";
import {useLocation} from "react-router-dom";

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`tabpanel-${index}`}
            aria-labelledby={`tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ padding: '24px 0 24px 0' }}>
                    {children}
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `tab-${index}`,
        'aria-controls': `tabpanel-${index}`,
    };
}

const tabs = [
    {name: 'default', index: 0, color: false, label: 'All Hisps'},
    {name: 'totalErrors', index: 1, color: false, label: 'Fewest Errors'},
    {name: 'scores', index: 2, color: false, label: 'Lowest Scores'},
]

const StyledTaps = styled(Tabs)({
    '& .MuiButtonBase-root.Mui-selected': {
        fontWeight: 'bold',
        border: '1px solid #ddd',
    }
})

export default function PublishedTabPanel(props) {
    const {
        contributions
    } = props;

    const [value, setValue] = useState(0);
    const [sortedContributions, setSortedContributions] = useState();
    const { hispsLogo, allHispsLoading } = useSelector(state => state.allHisps);
    const [orderDirection, setOrderDirection] = useState('asc');
    const [valueToOrderBy, setValueToOrderBy] = useState('errors');

    const { state } = useLocation();
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getAllHisps());
        if (state) {
            setValue(state.id)
            // setSortedContributions(() => sortedRowInformation(contributions, getCustomComparator(orderDirection, state.type)));
        }
    }, [])

    // useEffect(() => {
    //
    //     setSortedContributions(() => sortedRowInformation(contributions, getCustomComparator(orderDirection, valueToOrderBy)));
    // }, [value])

    const handleChange = (event, newValue) => {
        // switch (newValue) {
        //     case 0:
        //         setSortedContributions(contributions);
        //         break;
        //     case 1:
        //         setValueToOrderBy('errors')
        //         break;
        //     case 2:
        //         setValueToOrderBy('score')
        //         break;
        //     default:
        //         setValueToOrderBy('hisp')
        // }

        setValue(newValue);
    };

    // const createSortHandler = (property) => (event) => {
    //     handleRequestSort(event, property);
    // }
    //
    // const handleRequestSort = (event, property) => {
    //     const isAscending = (valueToOrderBy === property && orderDirection === 'asc');
    //     setValueToOrderBy(property);
    //     setOrderDirection(isAscending ? 'desc' : 'asc');
    // }

    // const descendingCustomComparator = (a, b, orderBy) => {
    //     let o1,o2;
    //     switch(orderBy) {
    //         case 'errors':
    //             o1 = a.errorCount;
    //             o2 = b.errorCount;
    //             break;
    //         case 'score':
    //             o1 = calculateScore(a.alertCount, a.errorCount, a.warningCount,a.inputRecordCount);
    //             o2 = calculateScore(b.alertCount, b.errorCount, b.warningCount,b.inputRecordCount);
    //             break;
    //         default:
    //             o1 = a[orderBy];
    //             o2 = b[orderBy];
    //     }
    //
    //     if (o2 < o1) {
    //         return -1;
    //     } else if (o2 > o1) {
    //         return 1;
    //     } else {
    //         return 0;
    //     }
    // }
    //
    // const getCustomComparator = (order, orderBy) => {
    //     return order === 'desc'
    //         ? (a, b) => descendingCustomComparator(a, b, orderBy)
    //         : (a, b) => -descendingCustomComparator(a, b, orderBy);
    // }

    return (
        <Box sx={{ width: '100%', pt: 2 }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <StyledTaps value={value} onChange={handleChange} aria-label="published tabs">
                        { tabs.map( tab => (
                            <Tab
                                label={tab.label}
                                {...a11yProps(tab.index)}
                                key={tab.name}
                                sx={{ backgroundColor: tab.color, borderRadius: '8px 8px 0 0'}}/>
                        ))}
                    </StyledTaps>
            </Box>
            {hispsLogo && contributions &&
                <>
                    <TabPanel value={value} index={0}>
                        <ContributionsAsList contributions={contributions} minimum={false} hispsLogo={hispsLogo}/>
                    </TabPanel>
                    <TabPanel value={value} index={1}>
                        {/*{sortedContributions && <PublishedErrorTable contributions={sortedContributions} hispsLogo={hispsLogo}/>}*/}
                        <PublishedErrorTable contributions={contributions} hispsLogo={hispsLogo}/>
                    </TabPanel>
                    <TabPanel value={value} index={2}>
                        {/*{sortedContributions && <PublishedScoreTable contributions={sortedContributions} hispsLogo={hispsLogo}/>}*/}
                        <PublishedScoreTable contributions={contributions} hispsLogo={hispsLogo}/>
                    </TabPanel>
                </>
            }
            <CustomBackdrop open={allHispsLoading} />
        </Box>
    );
}
